import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faLocationDot } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PinIcons } from 'pages/special/OsloDesignFair/map/mapConstants';
import { variantShadow } from 'pages/special/OsloDesignFair/map/markers/view/VariantIconMarkers/VariantIconMarker/shared/variantUtils';
import styled, { CSSProperties } from 'styled-components';

interface VariantIconProps {
    color: string;
    icon: string;
    style?: CSSProperties;
    className?: string;
}

export const VariantIcon = (props: VariantIconProps) => {
    function getIcon() {
        const icon = PinIcons.find((icon) => icon.value === props.icon);
        if (icon) {
            return icon?.icon;
        }
        return faLocationDot;
    }

    return (
        <S_VariantIcon $color={props.color} className={props.className} style={props.style}>
            <S_Icon icon={getIcon() as IconProp} />
            <S_Arrow />
        </S_VariantIcon>
    );
};

const S_VariantIcon = styled.div<{ $color: string }>`
    width: 30px;
    height: 30px;
    background-color: ${({ $color }) => $color};
    border-radius: 7px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: ${variantShadow};
    border: 2px solid ${({ theme }) => theme.colors.white};
    position: relative;
`;

const S_Icon = styled(FontAwesomeIcon)`
    color: ${({ theme }) => theme.colors.white};
    font-size: 14px;
    margin-top: -1px;
    filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.3));
`;

const S_Arrow = styled.div`
    position: absolute;
    bottom: -6px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 4px solid ${({ theme }) => theme.colors.white};
`;
